export default __webpack_public_path__ + "static/media/samuel.c85e873f.jpeg";